export default __webpack_public_path__ + "static/media/image_full_25.893b6e29.svg";